if (!customElements.get('quick-cart-drawer')) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
        this.parentElement.addEventListener('shopify:section:select', () => this.open());
        this.parentElement.addEventListener('shopify:section:deselect', () => this.close());
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleState = false;

      if (!this.classList.contains('is--open')) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }

      this.querySelector('.button--close').addEventListener('click', this.close.bind(this));
      this.querySelector('.quick-cart-drawer__backdrop').addEventListener('click', this.close.bind(this));

      // Close on click outside for desktop overlay mode
      document.addEventListener('click', (e) => {
        if (this.toggleState && this.classList.contains('is--desktop-overlay')) {
          const blocks = this.querySelector('.quick-cart-drawer__blocks');
          if (blocks && !blocks.contains(e.target) && !e.target.closest('.quick-cart-drawer__trigger')) {
            this.close();
          }
        }
      });

      // Close on Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.toggleState) {
          this.close();
        }
        if (e.key === 'Escape' && this._activeOverlay) {
          this.closeInlineOverlay();
        }
      });

      this.querySelector('.quick-cart-drawer__blocks').addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.toggleState) {
          this.close();
        }

        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];

          let isTabPressed = e.key === 'Tab';

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });

      this.initTriggers();
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document.querySelectorAll('.quick-cart-drawer__trigger').forEach(element => {
          if (!element._init) {
            // Daha önce eklenmiş mi kontrol edin
            element.addEventListener('click', event => {
              this.fetchProductForQuickCartDrawer(event);
            });
            element._init = true; // Eklenmiş olarak işaretleyin
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    async fetchProductForQuickCartDrawer(event) {
      /** stop autoplay on quick cart trigger */
      if (event.target.closest('card-product-slider')) {
        event.target.closest('card-product-slider').slider.autoplay.stop();
        event.target.closest('card-product-slider').classList.add('product--open-on-quick-cart');
      }

      const productCard = event.target.closest('product-card');
      if (!productCard) return;

      // Check for inline size overlay (instant, no fetch)
      const inlineOverlay = productCard.querySelector('.quick-size-overlay');
      if (inlineOverlay) {
        this.openInlineOverlay(inlineOverlay, productCard);
        return;
      }

      // Fallback: original drawer fetch for cards without inline overlay
      this._triggerCard = productCard;
      const isRecommendations = event.target.classList.contains('quick-cart-drawer__trigger--recommendations');
      let productOptions = null;

      if (!isRecommendations) {
        productOptions = productCard.querySelectorAll('input[type="radio"]:checked, select');
      }

      const trigger = event.target.closest('[data-product-url]');
      trigger.classList.toggle('is--loading');
      try {
        let fetchPrefix = '';
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }

        const productCardResponse = await fetch(`${fetchPrefix}${trigger.dataset.productUrl}/?view=quick-cart`);
        if (!productCardResponse) return;

        const productCardHTML = await productCardResponse.text();
        const fetchedCard = document.createElement('DIV');
        fetchedCard.insertAdjacentHTML('beforeend', productCardHTML);
        if (!fetchedCard.querySelector('.quick-cart-product')) return;
        this.querySelector('.quick-cart-drawer__main').innerHTML = '';
        this.querySelector('.quick-cart-drawer__main').append(fetchedCard.querySelector('.quick-cart-product'));
      } catch (error) {
      } finally {
        trigger.classList.toggle('is--loading');
        this.open();
      }
    }

    openInlineOverlay(overlay, productCard) {
      // Close any other open overlays
      document.querySelectorAll('.quick-size-overlay.is-active').forEach(el => {
        el.classList.remove('is-active');
      });

      // Reset all button styles (fix: previous selection staying highlighted)
      overlay.querySelectorAll('.quick-size-overlay__btn').forEach(btn => {
        btn.style.borderColor = '';
        btn.style.borderWidth = '';
      });

      // On mobile: move overlay to body so it's a true bottom sheet (not clipped by card)
      if (window.innerWidth < 750) {
        if (!overlay.dataset.originalParent) {
          overlay.dataset.originalParent = 'true';
          overlay._originalParent = overlay.parentElement;
          overlay._originalNextSibling = overlay.nextSibling;
        }
        document.body.appendChild(overlay);
      } else {
        // On desktop: make sure overlay is back in the card
        if (overlay._originalParent && overlay.parentElement === document.body) {
          if (overlay._originalNextSibling) {
            overlay._originalParent.insertBefore(overlay, overlay._originalNextSibling);
          } else {
            overlay._originalParent.appendChild(overlay);
          }
        }
      }

      overlay.classList.add('is-active');
      this._activeOverlay = overlay;
      this._activeProductCard = productCard;

      // Get variant data from the product card
      const variantsJson = productCard.querySelector('[data-product-variants-json]');
      let variants = [];
      if (variantsJson) {
        try { variants = JSON.parse(variantsJson.textContent); } catch(e) {}
      }

      // Get currently selected color (option1 for most themes)
      const checkedColorInput = productCard.querySelector('input[type="radio"]:checked');
      let currentColor = null;
      if (checkedColorInput) {
        currentColor = checkedColorInput.value;
      }

      // Close button
      const closeBtn = overlay.querySelector('.quick-size-overlay__close');
      if (closeBtn && !closeBtn._bound) {
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.closeInlineOverlay();
        });
        closeBtn._bound = true;
      }

      // Size buttons — add to cart on click
      overlay.querySelectorAll('.quick-size-overlay__btn:not([disabled])').forEach(btn => {
        if (btn._bound) return;
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          const sizeValue = btn.dataset.sizeValue;
          const optionPosition = parseInt(btn.dataset.optionPosition);

          // Find matching variant
          let matchedVariant = null;
          for (const v of variants) {
            if (!v.available) continue;
            const optionKey = 'option' + optionPosition;
            if (v[optionKey] === sizeValue) {
              if (currentColor && optionPosition !== 1 && v.option1 !== currentColor) continue;
              matchedVariant = v;
              break;
            }
          }
          if (!matchedVariant) {
            for (const v of variants) {
              if (!v.available) continue;
              if (v['option' + optionPosition] === sizeValue) {
                matchedVariant = v;
                break;
              }
            }
          }

          if (!matchedVariant) return;

          // Highlight selected button
          overlay.querySelectorAll('.quick-size-overlay__btn').forEach(b => {
            b.style.borderColor = '';
            b.style.borderWidth = '';
          });
          btn.style.borderColor = '#000';
          btn.style.borderWidth = '2px';

          // Close overlay immediately
          this.closeInlineOverlay();

          const cartDrawer = document.querySelector('cart-drawer');

          // Step 1: Open drawer IMMEDIATELY (optimistic)
          if (cartDrawer) {
            cartDrawer.open();
          }

          // Step 2: Fire add-to-cart WITHOUT sections (fast)
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: matchedVariant.id, quantity: 1 })
          })
          .then(r => r.json())
          .then(data => {
            if (!data.id && !data.items) return;

            // Step 3: Update counters
            if (typeof updateCartCounters === 'function') {
              updateCartCounters();
            }

            // Step 4: Fetch updated sections and swap content
            return fetch(window.location.pathname + '?sections=cart-drawer,cart-counter')
              .then(r => r.json())
              .then(sections => {
                if (cartDrawer) {
                  cartDrawer.renderContents({ sections }, false);
                }
                if (typeof updateCartCounters === 'function') {
                  updateCartCounters();
                }
                if (typeof updateFreeShipping === 'function') {
                  updateFreeShipping();
                }
              });
          })
          .catch(() => {});
        });
        btn._bound = true;
      });

      // Close on click outside (for desktop)
      if (!this._overlayOutsideClickBound) {
        document.addEventListener('click', (e) => {
          if (this._activeOverlay && this._activeOverlay.classList.contains('is-active')) {
            if (!this._activeOverlay.contains(e.target) && !e.target.closest('.quick-cart-drawer__trigger')) {
              this.closeInlineOverlay();
            }
          }
        });
        this._overlayOutsideClickBound = true;
      }

      // Mobile: close on backdrop click
      if (!overlay._backdropBound) {
        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) {
            this.closeInlineOverlay();
          }
        });
        overlay._backdropBound = true;
      }
    }

    closeInlineOverlay() {
      if (this._activeOverlay) {
        this._activeOverlay.classList.remove('is-active');

        // Move overlay back to its card if it was moved to body (mobile)
        if (this._activeOverlay._originalParent && this._activeOverlay.parentElement === document.body) {
          if (this._activeOverlay._originalNextSibling) {
            this._activeOverlay._originalParent.insertBefore(this._activeOverlay, this._activeOverlay._originalNextSibling);
          } else {
            this._activeOverlay._originalParent.appendChild(this._activeOverlay);
          }
        }

        this._activeOverlay = null;
      }
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(this.querySelectorAll('[data-media-id]')).find(media => Number(media.dataset.mediaId) === id);
      if (mediaFound) {
        this.sliderInstance.slideTo(Number(mediaFound.dataset.index));
      }
    }

    /** Drawer coreß functions */
    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      const quickCartDrawer = document.querySelector('.quick-cart-drawer__blocks');
      const closeButton = quickCartDrawer.querySelector('.button--close');
      closeButton.setAttribute('tabindex', '0');

      // Reset any previous inline positioning
      quickCartDrawer.style.cssText = '';

      if (window.innerWidth >= 750 && this._triggerCard) {
        // DESKTOP: no modal — just overlay on the product card
        // Do NOT lock body scroll or show backdrop
        const cardRect = this._triggerCard.getBoundingClientRect();
        quickCartDrawer.style.position = 'fixed';
        quickCartDrawer.style.top = (cardRect.top) + 'px';
        quickCartDrawer.style.left = cardRect.left + 'px';
        quickCartDrawer.style.width = cardRect.width + 'px';
        quickCartDrawer.style.height = cardRect.height + 'px';
        quickCartDrawer.style.transform = 'none';
        quickCartDrawer.style.opacity = '1';
        quickCartDrawer.style.pointerEvents = 'auto';
        quickCartDrawer.style.display = 'flex';
        quickCartDrawer.style.flexDirection = 'column';
        quickCartDrawer.style.justifyContent = 'flex-end';
        quickCartDrawer.style.background = 'transparent';
        quickCartDrawer.style.overflow = 'hidden';
        quickCartDrawer.style.borderRadius = '0';
        quickCartDrawer.style.boxShadow = 'none';
        this.classList.add('is--open', 'is--desktop-overlay');
      } else {
        // MOBILE: bottom sheet with body lock
        document.querySelector('body').classList.add('overflow-hidden');
        this.classList.add('is--open');
        this.classList.remove('is--desktop-overlay');
      }

      this.opened();
    }

    close() {
      this.toggleState = false;

      // Reset inline positioning styles
      const quickCartDrawer = document.querySelector('.quick-cart-drawer__blocks');
      if (quickCartDrawer) {
        quickCartDrawer.style.cssText = '';
      }

      const shopTheLookDrawer = document.querySelector('shop-the-look-drawer');

      // Only remove overflow-hidden if it was a mobile open (not desktop overlay)
      if (!this.classList.contains('is--desktop-overlay')) {
        if (shopTheLookDrawer && !shopTheLookDrawer.classList.contains('is--open')) {
          document.querySelector('body').classList.remove('overflow-hidden');
        }
        if (!shopTheLookDrawer) {
          document.querySelector('body').classList.remove('overflow-hidden');
        }
      }

      this.classList.remove('is--open', 'is--desktop-overlay');
      this.closed();
      this.toggleAriaExpanded();

      /** start autoplay on quick cart drawe close */
      if (document.querySelector('card-product-slider.product--open-on-quick-cart')) {
        document.querySelector('card-product-slider.product--open-on-quick-cart').slider.autoplay.start();
        document.querySelector('card-product-slider.product--open-on-quick-cart').classList.remove('product--open-on-quick-cart');
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest('button')) event.target.closest('button').setAttribute('aria-expanded', true);
        this.querySelector('.button--close').setAttribute('aria-expanded', true);
      } else {
        document.querySelectorAll('[aria-controls="quick-cart-drawer"]').forEach(button => {
          button.setAttribute('aria-expanded', false);
        });
      }
    }

    opened() {
      const openedEvent = new Event('opened', { bubbles: true });
      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event('closed', { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define('quick-cart-drawer', QuickCartDrawer);
}
